import { call, put, takeLatest } from 'redux-saga/effects'
import * as messagingApi from '../apiModules/messaging'
import * as messagingModule from '../modules/messaging'

function* fetchMessagingData({ payload }) {
  try {
    const response = yield call(messagingApi.fetchMessagingData, payload)
    yield put(messagingModule.fetchMessagingDataSuccess(response))
  } catch (err) {
    yield put(messagingModule.fetchMessagingDataFailure(err))
  }
}

function* triggerMessagesDispatch({ payload }) {
  try {
    yield call(messagingApi.triggerMessages, payload)
    yield put(messagingModule.triggerMessagesDispatchSuccess())
  } catch (err) {
    yield put(messagingModule.triggerMessagesDispatchFailure(err))
  }
}

export const messagingSagas = [
  takeLatest(messagingModule.FETCH_MESSAGING_DATA, fetchMessagingData),
  takeLatest(messagingModule.TRIGGER_MESSAGES_DISPATCH, triggerMessagesDispatch)
]
